import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class LoaderService {
    isLoading = new Subject<boolean>();
    force: boolean = false;

    show() {
        this.isLoading.next(true);
    }

    setForced(force){
        this.force = force;
    }

    hide(close?) {
        if(!this.force)
            this.isLoading.next(false);
        else{
            if(close == true){
                this.isLoading.next(false);
            }
        }

    }
};
